import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { CustomViewZoom } from 'components/CustomViewZoom'

import styles from './styles.module.scss'


interface IProps {
  palette: string[][]
}

export const ImagesPalette: FC<IProps> = ({palette}) => {
  return (
    <div className={styles.paletteContainer}>
      {palette.map((section, idx) => {
        return (
          <div className={styles.paletteSection} key={idx}>
            {section.map(url => <CustomViewZoom imgUrl={url} key={url}/>)}
          </div>
        )
      })}
    </div>
  )
}
